import { render, staticRenderFns } from "./xunLDetail.vue?vue&type=template&id=633d0565&"
import script from "./xunLDetail.vue?vue&type=script&lang=js&"
export * from "./xunLDetail.vue?vue&type=script&lang=js&"
import style0 from "./xunLDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports